module.exports = __webpack_public_path__ + "img/mgh-otemachi@2x.93bd9687.jpg";